module.exports = __webpack_public_path__ + "static/img/qrcode.897a3fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/qrcode.png
// module id = ULk9
// module chunks = 1